var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#84D5DC",
    fillOpacity: 0.1,
    stroke: "#51A3AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1348 6.3999L7.66602 8.07568C7.25781 8.22607 7 8.61279 7 9.04248V13.8765C7 14.2632 7.21484 14.6284 7.55859 14.8003L12.0273 17.0347C12.3281 17.1851 12.6504 17.1851 12.9512 17.0347L17.4199 14.8003C17.7637 14.6284 17.9785 14.2632 17.9785 13.8765V9.04248C17.9785 8.61279 17.7207 8.22607 17.3125 8.07568L12.8438 6.3999C12.6289 6.31396 12.3711 6.31396 12.1348 6.3999ZM12.5 7.73193L16.625 9.27881V9.30029L12.5 10.9761L8.375 9.30029V9.27881L12.5 7.73193ZM13.1875 15.3804V12.1792L16.625 10.7827V13.6616L13.1875 15.3804Z",
    fill: "#51A3AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.d75befb689e1f526815f79e2f322ea65.svg";
export { ForwardRef as ReactComponent };